/**
 * Hook to determine if the host is also playing in the game
 * @param roomState - The current room state
 * @returns boolean indicating if host is playing
 */
export function useHostPlaying(roomState: {
  hostId: string;
  players: Array<{ id: string }>;
}): boolean {
  if (!roomState || !roomState.hostId || !roomState.players) {
    return false;
  }
  const isPlaying = roomState.players.some(p => p.id === roomState.hostId);
  // Debug logging removed to prevent excessive console output during tests
  // To enable debug logging, uncomment the line below:
  // console.log('[useHostPlaying] hostId:', roomState.hostId, 'players:', roomState.players.map(p => p.id), 'isPlaying:', isPlaying);
  return isPlaying;
}
